var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsscan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8125,
    cy: 13.0625,
    r: 12.375,
    fill: "url(#paint0_radial_52_451)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74953 11.3694L12.5008 8.61816L15.2544 11.3718L16.8551 9.771L12.5008 5.41663L8.14876 9.76864L9.74953 11.3694ZM5.41675 12.5005L7.0171 10.9001L8.61745 12.5005L7.0171 14.1008L5.41675 12.5005ZM12.5008 16.3839L9.74951 13.6326L8.14639 15.2311L8.14874 15.2334L12.5008 19.5854L16.8551 15.2311L15.2544 13.6303L12.5008 16.3839ZM16.3827 12.5016L17.9831 10.9012L19.5834 12.5016L17.9831 14.1019L16.3827 12.5016ZM12.5008 10.8767L14.1251 12.501L12.5008 14.1277L10.8764 12.5034V12.4987L11.1617 12.2134L11.3008 12.0767L12.5008 10.8767Z",
    fill: "#7567BA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_52_451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.44485 8.60386) rotate(56.0702) scale(18.095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564858,
    stopColor: "#ADA4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C85"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsscan);
export default __webpack_public_path__ + "static/media/bsscan.543bdab89c65f0e7220f49a28009fed9.svg";
export { ForwardRef as ReactComponent };